import React from 'react';

function AuthBottom({ className, children }) {
  return (
    <div className={`auth-bottom ${className}`}>
      <div className="child">{children}</div>
    </div>
  );
}

export default AuthBottom;
